import { Plus } from 'lucide-solid';
import { mergeProps } from 'solid-js';
import { Button } from '~/components/ui/Button';
import { Localized } from '~/i18n';

type MultiAppHeaderProps = {
  btnOnClick: () => void;
};

export default function MultiAppHeader(props: MultiAppHeaderProps) {
  const merged = mergeProps({}, props);
  return (
    <div class="flex justify-between">
      <div>
        <h1 class={`text-2xl`}>
          <Localized translationKey="pages.multi_applications.page_header" />
        </h1>
        <p class="text-fg-muted text-sm mt-1">
          <Localized translationKey="pages.multi_applications.sub_header" />
        </p>
      </div>
      <Button onClick={merged.btnOnClick}>
        <span class="flex items-center gap-2">
          <Plus />
          <Localized translationKey="pages.multi_applications.create_application" />
        </span>
      </Button>
    </div>
  );
}
